import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import * as Config from 'common/config.js';
import LoginContainer from 'common/auth/LoginContainer.js';
import LoginCallback from 'common/auth/LoginCallback.js';
import SigninSilentCallback from 'common/auth/SigninSilentCallback.js';
import Logout from 'common/auth/LogoutContainer.js';
import HomeContainer from 'home/HomeContainer.js';
import CustomerDetailsContainer from 'customerDetails/CustomerDetailsContainer.js';
import { ReactComponent as CustomerSvg } from 'assets/ic-customers-18px.svg';
import AccountSelectionContainer from 'accountSelection/AccountSelectionContainer.js';
import AddAccountContainer from 'addAccount/AddAccountContainer.js';
import TermsAndConditions from 'common/termsAndConditions/TermsAndConditionsContainer.js';
import AddAccountRedirect from 'addAccount/AddAccountRedirect.js';
import TransactionsContainer from 'transactions/TransactionsContainer.js';
import ProfileContainer from 'profile/ProfileContainer.js';
import TaxInvoicesContainer from 'taxInvoices/TaxInvoicesContainer.js';
import ErrorPage from 'common/error/Error';
import PrivateRoute from './PrivateRoute.js';

export const routes = [
  {
    path: '/Login',
    name: '',
    component: LoginContainer,
    display: false,
    private: false,
  },
  {
    path: '/LoginCallback',
    name: '',
    component: LoginCallback,
    display: false,
    private: false,
  },
  {
    path: '/ErrorPage',
    name: '',
    component: ErrorPage,
    display: false,
    private: false,
  },

  {
    path: '/SigninSilentCallback',
    name: '',
    component: SigninSilentCallback,
    display: false,
    private: false,
  },

  {
    path: '/',
    name: 'Home',
    component: HomeContainer,
    icon: CustomerSvg,
    display: false,
    private: true,
  },
  {
    path: '/Accounts',
    name: 'Accounts',
    component: AccountSelectionContainer,
    icon: CustomerSvg,
    display: true,
    private: true,
    hideMenu: true,
    menuGroup: 'profile',
  },
  {
    path: '/CustomerDetails/:adfitNo',
    name: 'Summary',
    component: CustomerDetailsContainer,
    icon: CustomerSvg,
    display: true,
    private: true,
    menuGroup: 'main',
  },

  {
    path: '/AddAccount',
    name: 'Add Account',
    component: AddAccountContainer,
    icon: CustomerSvg,
    display: false,
    private: true,
    hideMenu: true,
  },
  {
    path: '/AddAccountRedirect',
    name: 'Add Account Redirect',
    component: AddAccountRedirect,
    icon: CustomerSvg,
    display: false,
    private: true,
    hideMenu: true,
  },

  {
    path: '/Profile/:adfitNo',
    name: 'Details',
    component: ProfileContainer,
    icon: CustomerSvg,
    display: true,
    private: true,
    menuGroup: 'main',
  },
    
  {
    name: 'Change Password',
    externalUrl: Config.oidcConfig.authority + '/Account/ChangePassword',
    display: true,
    private: true,
    menuGroup: 'profile',
  },

  {
    path: '/Transactions/:adfitNo',
    name: 'Transactions',
    component: TransactionsContainer,
    icon: CustomerSvg,
    display: true,
    private: true,
    menuGroup: 'main',
  },

  {
    path: '/TaxInvoices/:adfitNo',
    name: 'Invoices',
    component: TaxInvoicesContainer,
    icon: CustomerSvg,
    display: true,
    private: true,
    menuGroup: 'main',
  },

  {
    path: '/Terms',
    name: 'Terms and Conditions',
    component: TermsAndConditions,
    display: true,
    private: true,
    menuGroup: 'profile',
  },

  {
    path: '/Logout',
    name: 'Logout',
    component: Logout,
    display: true,
    private: false,
    menuGroup: 'profile',
  },

  { path: 'no-match', redirectToPath: '/' }, //all other route will be redirected to route, has to be last one
];

const mapRoute = (route, key) => {
  if (route.path === 'no-match') {
    return (
      <Route render={() => <Redirect to={route.redirectToPath} />} key={key} />
    );
  } else if (route.private) {
    return (
      <PrivateRoute
        exact
        path={route.path}
        component={route.component}
        key={key}
        hideMenu={route.hideMenu}
      />
    );
  } else {
    return <Route path={route.path} component={route.component} key={key} />;
  }
};

export const getRoutes = () => {
  const allRoutes = [];
  routes.forEach((route) => {
    if (route.subRoutes) {
      route.subRoutes.forEach((r) => {
        allRoutes.push(r);
      });
    } else {
      allRoutes.push(route);
    }
  });

  return allRoutes.filter((m) => m.path).map(mapRoute);
};

export const getRouteName = (routes, path) => {
  let val = '';
  for (let i = 0; i < routes.length; i++) {
    const route = routes[i];
    if (route.path === path) {
      val = route.name;
      break;
    }
    if (route.subRoutes) {
      const sub = route.subRoutes.find((r) => (r = r.path === path));
      if (sub) {
        val = sub.name;
        break;
      }
    }
  }
  return val;
};

export const getRoutesForMenu = (routes, menuGroup) => {
  const menuRoutes = routes
    .filter(
      (route) =>
        route.display && (!route.menuGroup || route.menuGroup === menuGroup)
    )
    //&& (!route.roles || SecurityService.userHasSomePermissions(userPermissions, ...route.roles.split(','))))
    .map((route) => {
      const menuRoute = {
        name: route.name,
        path: route.path || route.externalUrl,
        icon: route.icon,
        selected: false,
        isExternal: route.hasOwnProperty('externalUrl'),
      };
      if (route.subRoutes) {
        menuRoute.subRoutes = getRoutesForMenu(route.subRoutes, menuGroup);
      }
      return menuRoute;
    });
  return menuRoutes;
};

export const showCustomerDetailsTabs = (path) => {
  return /^\/customers\/[a-z0-9/]+$/.test(path.toLowerCase());
};
